/** 16×16 网格上的像素小人，按整数 scale 绘制以保持清晰 */

import { outfitToPalette, normalizeOutfit } from '@/game/outfit'

const PALETTES = {
  self: {
    hair: '#5b8fd4',
    hairLight: '#8eb8f0',
    skin: '#ffcc99',
    skinShade: '#e8a86a',
    shirt: '#4ecdc4',
    shirtDark: '#2a9d8f',
    pants: '#2d4059',
    pantsDark: '#1a2634',
    shoe: '#1e1e1e',
    accent: '#7ee8fa'
  },
  other: {
    hair: '#c17f59',
    hairLight: '#e8a87c',
    skin: '#ffcc99',
    skinShade: '#e8a86a',
    shirt: '#ff9f43',
    shirtDark: '#d97828',
    pants: '#6b4c35',
    pantsDark: '#4a3424',
    shoe: '#1e1e1e',
    accent: '#ffd166'
  },
  mcd: {
    hair: '#d4a017',
    hairLight: '#f0c040',
    skin: '#ffcc99',
    skinShade: '#e8a86a',
    shirt: '#e74c3c',
    shirtDark: '#c0392b',
    pants: '#2c2c2c',
    pantsDark: '#1a1a1a',
    shoe: '#1e1e1e',
    accent: '#f1c40f',
    hat: '#e74c3c'
  },
  witch: {
    hair: '#6c3483',
    hairLight: '#9b59b6',
    skin: '#d4b5e0',
    skinShade: '#a87bb8',
    shirt: '#4a235a',
    shirtDark: '#2e1538',
    pants: '#1a1a2e',
    pantsDark: '#0f0f1a',
    shoe: '#1e1e1e',
    accent: '#bb8fce',
    hat: '#4a235a'
  },
  stylist: {
    hair: '#e84393',
    hairLight: '#fd79a8',
    skin: '#ffcc99',
    skinShade: '#e8a86a',
    shirt: '#fd79a8',
    shirtDark: '#e84393',
    pants: '#6c5ce7',
    pantsDark: '#4834d4',
    shoe: '#1e1e1e',
    accent: '#ffeaa7',
    hat: '#fd79a8'
  },
  bobby: {
    hair: '#c49a6c',
    hairLight: '#e0b88a',
    skin: '#ffcc99',
    skinShade: '#e8a86a',
    shirt: '#74b9ff',
    shirtDark: '#0984e3',
    pants: '#dfe6e9',
    pantsDark: '#b2bec3',
    shoe: '#2d3436',
    accent: '#ffeaa7',
    hat: '#fdcb6e'
  },
  lark: {
    hair: '#7cb342',
    hairLight: '#aed581',
    skin: '#ffcc99',
    skinShade: '#e8a86a',
    shirt: '#c5e1a5',
    shirtDark: '#7cb342',
    pants: '#558b2f',
    pantsDark: '#33691e',
    shoe: '#2d3436',
    accent: '#ffeb3b',
    hat: '#8bc34a'
  },
  pixie: {
    hair: '#80deea',
    hairLight: '#e0f7fa',
    skin: '#ffd9b3',
    skinShade: '#efb486',
    shirt: '#b2ebf2',
    shirtDark: '#26a6c4',
    pants: '#4dd0e1',
    pantsDark: '#0f7f9c',
    shoe: '#2d3436',
    accent: '#fff59d',
    hat: '#ffffff'
  },
  pirate: {
    hair: '#1a1a1a',
    hairLight: '#333333',
    skin: '#ffcc99',
    skinShade: '#e8a86a',
    shirt: '#e74c3c',
    shirtDark: '#c0392b',
    pants: '#2c3e50',
    pantsDark: '#1a252f',
    shoe: '#1e1e1e',
    accent: '#f1c40f',
    hat: '#f1c40f'
  }
}

function paletteFor (role, username, outfit) {
  if (outfit) return outfitToPalette(outfit)
  if (role === 'mcd' || role === 'witch' || role === 'stylist' || role === 'bobby' || role === 'lark' || role === 'pixie' || role === 'pirate') {
    return PALETTES[role]
  }
  if (role === 'self') return PALETTES.self
  if (!username) return PALETTES.other
  let h = 0
  for (let i = 0; i < username.length; i++) h = (h * 31 + username.charCodeAt(i)) >>> 0
  return h % 2 === 0 ? PALETTES.self : PALETTES.other
}

function drawHat (fill, hat, pal, facing) {
  if (!hat || hat === 'none' || facing === 'up') return
  const c = pal.accent
  const d = pal.shirtDark
  if (hat === 'cap') {
    fill(4, 0, 8, 2, d)
    fill(5, 0, 6, 1, c)
    fill(3, 1, 3, 1, d)
  } else if (hat === 'bow') {
    fill(5, 0, 2, 2, c)
    fill(9, 0, 2, 2, c)
    fill(7, 0, 2, 1, pal.shirt)
  } else if (hat === 'crown') {
    fill(5, 0, 6, 2, c)
    fill(5, 0, 2, 1, pal.accent)
    fill(7, 0, 2, 1, pal.accent)
    fill(9, 0, 2, 1, pal.accent)
  } else if (hat === 'beanie') {
    fill(4, 0, 8, 3, d)
    fill(5, 1, 6, 2, c)
    fill(4, 3, 8, 1, pal.skinShade)
  }
}

function drawNpcRoleHat (fill, role, pal) {
  const hatColor = pal.hat || pal.hair
  if (role === 'witch') {
    fill(7, 0, 2, 2, hatColor)
    fill(5, 1, 6, 1, hatColor)
  } else if (role === 'mcd') {
    fill(4, 0, 8, 2, hatColor)
    fill(5, 0, 6, 1, pal.accent)
  } else if (role === 'stylist') {
    fill(4, 0, 8, 2, hatColor)
    fill(6, 0, 4, 1, pal.accent)
    fill(5, 0, 1, 2, '#fff')
    fill(10, 0, 1, 2, '#fff')
  } else if (role === 'bobby') {
    fill(5, 1, 6, 3, hatColor)
    fill(4, 3, 2, 2, hatColor)
    fill(10, 3, 2, 2, hatColor)
    fill(6, 0, 4, 2, pal.accent)
  } else if (role === 'lark') {
    fill(5, 0, 6, 2, hatColor)
    fill(4, 1, 2, 1, pal.accent)
    fill(10, 1, 2, 1, pal.accent)
    fill(7, 0, 2, 1, '#fffde7')
  } else if (role === 'pixie') {
    // 头顶小星星触角 + 两侧透明翅膀
    fill(7, 0, 2, 1, pal.accent)
    fill(6, 1, 1, 1, pal.accent)
    fill(9, 1, 1, 1, pal.accent)
    fill(5, 2, 6, 1, pal.hairLight)
    fill(1, 6, 2, 3, 'rgba(224, 247, 250, 0.9)')
    fill(13, 6, 2, 3, 'rgba(224, 247, 250, 0.9)')
    fill(0, 7, 1, 2, 'rgba(178, 235, 242, 0.85)')
    fill(15, 7, 1, 2, 'rgba(178, 235, 242, 0.85)')
  } else if (role === 'pirate') {
    fill(3, 0, 10, 2, hatColor)
    fill(4, 0, 8, 1, pal.accent)
    fill(2, 1, 3, 1, hatColor)
    fill(11, 1, 3, 1, hatColor)
    fill(5, 2, 6, 1, pal.shirtDark)
  }
}

function drawFootShadow (ctx, ox, oyDraw, s, color) {
  ctx.fillStyle = color
  ctx.beginPath()
  ctx.ellipse(ox + 8 * s, oyDraw + 15 * s, 5.5 * s, 1.8 * s, 0, 0, Math.PI * 2)
  ctx.fill()
  ctx.imageSmoothingEnabled = false
}

/**
 * 在 tile 左上角 (originX, originY) 绘制 16×16 逻辑像素的角色
 * @param {number} scale 整数倍缩放（1/2/3）
 */
export function drawPixelPerson (ctx, originX, originY, scale, opts = {}) {
  const {
    role = 'other',
    username = '',
    facing = 'down',
    walkPhase = 0,
    isSelf = false,
    showHat = false,
    seated = false,
    outfit = null
  } = opts

  const normalizedOutfit = outfit ? normalizeOutfit(outfit) : null
  const pal = paletteFor(isSelf && !normalizedOutfit ? 'self' : role, username, normalizedOutfit)
  const hatStyle = normalizedOutfit?.hat
  const topStyle = normalizedOutfit?.top || 'tee'
  ctx.imageSmoothingEnabled = false

  const ox = Math.floor(originX)
  const oy = Math.floor(originY)
  const s = scale

  const LEG_CYCLE = [0, 1, 0, -1]
  const leg = LEG_CYCLE[((Math.floor(walkPhase) % 4) + 4) % 4]
  const oyDraw = oy

  const fillBob = (x, y, w, h, color) => {
    if (!color) return
    ctx.fillStyle = color
    ctx.fillRect(ox + x * s, oyDraw + y * s, w * s, h * s)
  }

  if (seated) {
    ctx.fillStyle = 'rgba(0, 0, 0, 0.18)'
    ctx.beginPath()
    ctx.ellipse(ox + 8 * s, oyDraw + 12 * s, 4.5 * s, 1.4 * s, 0, 0, Math.PI * 2)
    ctx.fill()
    fillBob(3, 8, 10, 5, '#3d2817')
    fillBob(4, 9, 8, 3, '#4a3020')
    fillBob(5, 10, 6, 2, pal.pantsDark)
  } else if (isSelf) {
    drawFootShadow(ctx, ox, oyDraw, s, 'rgba(244, 196, 48, 0.48)')
  } else {
    drawFootShadow(ctx, ox, oyDraw, s, 'rgba(0, 0, 0, 0.22)')
  }

  if (!seated) {
    fillBob(5 + leg, 11, 2, 3, pal.pantsDark)
    fillBob(9 - leg, 11, 2, 3, pal.pants)
    fillBob(5 + leg, 14, 2, 1, pal.shoe)
    fillBob(9 - leg, 14, 2, 1, pal.shoe)
  }

  if (topStyle === 'hoodie') {
    fillBob(4, 6, 8, 6, pal.shirtDark)
    fillBob(5, 7, 6, 5, pal.shirt)
    fillBob(6, 5, 4, 2, pal.shirtDark)
  } else if (topStyle === 'vest') {
    fillBob(5, 7, 6, 5, pal.shirtDark)
    fillBob(6, 6, 4, 1, pal.shirt)
    fillBob(6, 8, 4, 3, pal.shirt)
  } else {
    fillBob(5, 7, 6, 5, pal.shirtDark)
    fillBob(6, 6, 4, 1, pal.shirt)
  }

  const armShift = facing === 'left' ? -1 : facing === 'right' ? 1 : 0
  if (seated && facing === 'down') {
    fillBob(2, 8, 2, 3, pal.shirt)
    fillBob(12, 8, 2, 3, pal.shirtDark)
    fillBob(1, 10, 2, 2, pal.skin)
    fillBob(13, 10, 2, 2, pal.skin)
  } else {
    fillBob(3 + armShift, 7, 2, 3, pal.shirt)
    fillBob(11 + armShift, 7, 2, 3, pal.shirtDark)
    fillBob(3 + armShift, 10, 2, 1, pal.skin)
    fillBob(11 + armShift, 10, 2, 1, pal.skin)
  }

  fillBob(5, 2, 6, 5, pal.skin)
  fillBob(5, 2, 6, 1, pal.skinShade)

  fillBob(4, 0, 8, 3, pal.hair)
  fillBob(4, 1, 2, 3, pal.hair)
  fillBob(10, 1, 2, 3, pal.hair)
  if (facing !== 'up') fillBob(6, 0, 4, 1, pal.hairLight)

  if (normalizedOutfit) {
    drawHat(fillBob, hatStyle, pal, facing)
  } else if (showHat || role === 'witch' || role === 'mcd' || role === 'stylist' || role === 'bobby' || role === 'lark' || role === 'pixie' || role === 'pirate') {
    drawNpcRoleHat(fillBob, role, pal)
  }

  if (facing !== 'up') {
    const eyeShift = facing === 'left' ? -1 : facing === 'right' ? 1 : 0
    fillBob(6 + eyeShift, 4, 1, 2, '#2c3e50')
    fillBob(9 + eyeShift, 4, 1, 2, '#2c3e50')
    fillBob(6 + eyeShift, 4, 1, 1, '#fff')
    fillBob(9 + eyeShift, 4, 1, 1, '#fff')
  }

  fillBob(5, 5, 1, 1, 'rgba(255,130,100,0.45)')
  fillBob(10, 5, 1, 1, 'rgba(255,130,100,0.45)')
}

export function drawNpcBadge (ctx, originX, originY, scale, emoji) {
  const ox = Math.floor(originX)
  const oy = Math.floor(originY)
  const s = scale
  ctx.fillStyle = 'rgba(0,0,0,0.55)'
  ctx.fillRect(ox + 3 * s, oy, 10 * s, 7 * s)
  ctx.font = `${Math.max(8, 6 * s)}px sans-serif`
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  ctx.fillStyle = '#fff'
  ctx.fillText(emoji, ox + 8 * s, oy + 3.5 * s)
}
